module.exports = prestashop;


/*****************
 ** WEBPACK FOOTER
 ** external "prestashop"
 ** module id = 49
 ** module chunks = 0
 **/